/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

// Started before Angular bootstraps, so it runs outside the Angular zone and session replay doesn't trigger
// change detection. HR screens show names, salaries and ID numbers, so all page text and form inputs are
// masked in recordings and in autocaptured clicks.
// Optional: an environment file without these keys still builds, with analytics turned off
const { posthogKey, posthogHost } = environment as { posthogKey?: string; posthogHost?: string };
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-08-30',
    person_profiles: 'identified_only',
    mask_all_text: true,
    mask_all_element_attributes: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
    },
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
